import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

interface IBranchInfo {
  name: string;
  address: string;
  phone: string;
}

export interface IAiConfig {
  is_reached_limit_request_ai_blog?: boolean;
  is_reached_limit_request_ai_seo?: boolean;
  is_reached_limit_request_ai_review?: boolean;
  is_reached_limit_request_ai_service?: boolean;
  is_reached_limit_request_ai_introduction?: boolean;
  is_done_survey?: boolean;
  blog_tour_guide_current_step?: number;
  seo_tour_guide_current_step?: number;
  review_tour_guide_current_step?: number;
  service_tour_guide_current_step?: number;
  introduction_tour_guide_current_step?: number;
  is_available_ai_system?: boolean;
}

interface IBranch {
  info: IBranchInfo;
  is_syncing: boolean;
  sync_data: any;
  ai_config?: IAiConfig;
}

const initialState: IBranch = {
  info: {
    name: "",
    address: "",
    phone: "",
  },
  is_syncing: false,
  sync_data: {},
  ai_config: {},
};

export const branchSlice = createSlice({
  name: "branch",
  initialState,
  reducers: {
    setBranchInfo: (state, action: PayloadAction<{ info: IBranchInfo }>) => {
      state.info = action.payload.info;
    },
    setSyncStatus: (state, action: PayloadAction<boolean>) => {
      state.is_syncing = action.payload;
    },
    setSyncData: (state, action: PayloadAction<any>) => {
      state.sync_data = action.payload;
    },
    setAiConfig: (state, action: PayloadAction<any>) => {
      state.ai_config = action.payload;
    }
  },
});

export const { setBranchInfo, setSyncStatus, setSyncData, setAiConfig } = branchSlice.actions;

export const selectBranchInfo = (state: RootState) => state.branch.info;
export const selectSyncStatus = (state: RootState) =>
  localStorage.getItem("force-is-syncing") === "true" ||
  state.branch.is_syncing;

export const selectSyncData = (state: RootState) => state.branch.sync_data
export const selectAiConfig = (state: RootState) => state.branch.ai_config

export default branchSlice.reducer;
